import React, { useState, useEffect } from "react";
import OrgChartBP from "../components/organigrama";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import JuntaDirectiva from "../components/JuntaDirectiva";
import { seccionesOrganos } from "../components/miembros";
import SocialBar from "../components/SocialBar";
import "../components/estructura.css";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';
import { Image } from "react-bootstrap";

const API_URL = "https://facach.coop.hn/api";

function Estructura() {

   const { settings } = useSiteSettings();
  const bannerSrc = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;
  const [mensajes, setMensajes] = useState(null);

  useEffect(() => {
    const fetchMensajes = async () => {
      try {
        const res = await fetch(`${API_URL}/leadership`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data) {
          // Mapear al formato que espera JuntaDirectiva
          // Cada tipo puede tener varios años — tomamos el más reciente (primero por ORDER BY year DESC)
          const mapMensaje = (tipo) => {
            const items = json.data[tipo];
            if (!items || items.length === 0) return null;
            // Devuelve el content_html del más reciente
            return [items[0].content_html];
          };

          setMensajes({
            directiva:  mapMensaje("junta_directiva")  || undefined,
            vigilancia: mapMensaje("junta_vigilancia")  || undefined,
            gerencia:   mapMensaje("gerencia_general")  || undefined,
          });
        }
      } catch (err) {
        console.error("Error cargando mensajes de directivos:", err.message);
        // Se queda con los mensajes por defecto de JuntaDirectiva
      }
    };

    fetchMensajes();
  }, []);

  return (
    <section style={{overflowX:'hidden'}}>
      <NavbarFacach />
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="..." fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">ESTRUCTURA ORGANIZACIONAL</h1>
        </div>
      </div>
      <OrgChartBP />

      <div className="container py-3">
        {/* Si mensajes es null pasa undefined y JuntaDirectiva usa sus defaults */}
        <JuntaDirectiva
          secciones={seccionesOrganos}
          maxWidth={1100}
          {...(mensajes ? { mensajes } : {})}
        />
      </div>

      <SocialBar position="right" top="35%" size={42} rounded={true} />
      <FooterFacach />
    </section>
  );
}

export default Estructura;